'use es6';

import { Record } from 'immutable';
import { cleanObject } from '../utils/formatters';
import uniqueId from 'hs-lodash/uniqueId';
import * as PlanType from '../constants/pricings/PlanType';
export default class Pricing extends Record({
  planType: PlanType.FREE,
  cents: 0,
  commitmentCents: 0,
  extraCharges: '',
  freeTrialDays: 0,
  meterUnit: '',
  contactUsUrl: '',
  contactUsPlanType: null,
  name: '',
  tagline: '',
  features: '',
  updatedAt: null,
  id: ''
}) {
  constructor(values) {
    super(Object.assign({}, cleanObject(values), {
      id: uniqueId('pricing-')
    }));
  } // 'id' is used as a unique key that persists as the record updates, for ListTransition


  equals(otherObj) {
    return this.delete('id').toString() === otherObj.delete('id').toString();
  }

}